import { ModalStyled } from '../Modals.styled'
import { Backdrop, Fade } from '@mui/material'
import { modalStyles } from '../ModalStyles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import SLTable from './SLTable'
import { useEffect, useState } from 'react'
import { formatPhone } from '../../helpers/formatPhone'
import { ShippingLocationsModalProps } from './models'
import { CountryOptions } from '../../data/CountryOptions'
import { calculateEmail } from '../../helpers/calculateEmail'
import axios from 'axios'
import { getCountriesWithoutZipcodes } from '../../constants/countries'

const GET_CONTACTS = '/applet/v1/database/contacts'


const ShippingLocationsModal = ({open, setOpen, setData, setFormikValues, formikValues, setShippingLocationLocal, formFor, forStops, setOpenClearRateToEditModal, setNewValuesWhenRateCleared, forVendorRequest, valueName, data, setOpenRemarksMessageModal, forDrayage, userData}: ShippingLocationsModalProps) => {
    const classes = modalStyles({})
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const [shippingLocation, setShippingLocation] = useState({}) as any
    const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        if(shippingLocation.name){
            // Normalize SL data to match ZipcodesWithCountry expected keys
            const rawCountry = shippingLocation?.country || shippingLocation?.Country || ''
            const normalizedCountry = rawCountry.length === 3
                ? (CountryOptions?.find(c => c.CodePrimus === rawCountry)?.Code || rawCountry)
                : rawCountry
            const normalizedSL = {
                ...shippingLocation,
                City: shippingLocation?.city || shippingLocation?.City || '',
                State: shippingLocation?.state || shippingLocation?.State || '',
                Zipcode: shippingLocation?.zipcode || shippingLocation?.Zipcode || '',
                Name: shippingLocation?.name || shippingLocation?.Name || '',
                Country: normalizedCountry,
                isSL: true,
                isZipcode: false,
                isCity: !shippingLocation?.zipcode && getCountriesWithoutZipcodes().includes(normalizedCountry),
                id: shippingLocation?.id || 0
            }
            if(formFor){
                if(formFor == 'pickupLocation') {
                    setData(normalizedSL)
                }
                else {
                    setData(normalizedSL)
                    setShippingLocationLocal(shippingLocation?.name)
                }
                if(!forStops){                    
                    setFormikValues(`${formFor}.name`, shippingLocation?.name || "")
                    setFormikValues(`${formFor}.address`, shippingLocation?.address || "")
                    setFormikValues(`${formFor}.address1`, shippingLocation?.address1 || "")
                    setFormikValues(`${formFor}.contact`, shippingLocation?.contact || "")
                    setFormikValues(`${formFor}.emails`, calculateEmail(shippingLocation?.email))
                    setFormikValues(`${formFor}.id`, shippingLocation?.id || "")
                    setFormikValues(`${formFor}.city`, shippingLocation?.city || "")
                    setFormikValues(`${formFor}.country`, normalizedCountry || "US")
                    setFormikValues(`${formFor}.state`, shippingLocation?.state || "")
                    setFormikValues(`${formFor}.zipcode`, shippingLocation?.zipcode || "")
                    setFormikValues(`${formFor}.phone`, formatPhone(shippingLocation?.phone, shippingLocation.country) || "")
                    setFormikValues(`${formFor}.contactPhone`, formatPhone(shippingLocation?.contactPhone, shippingLocation.country) || "")
                    setFormikValues(`${formFor}.remarks`, shippingLocation?.remarks || "")
                    setFormikValues(`${formFor === 'shipper' ? 'pickupDate' : 'deliveryDate'}.from`, formFor === 'shipper' ? (shippingLocation?.opentime || newBookingValues?.pickupTimeFrom) : shippingLocation?.opentime || "")
                    setFormikValues(`${formFor === 'shipper' ? 'pickupDate' : 'deliveryDate'}.to`, formFor === 'shipper' ? (shippingLocation?.closetime || newBookingValues?.pickupTimeTo) : shippingLocation?.closetime || "")
                    setFormikValues(`${formFor}.IATACode`, shippingLocation?.IATA || "")

                    // Auto-populate Emergency/Haz contact when selecting Shipper
                    if(formFor === 'shipper' && shippingLocation?.id){
                        axios.get(GET_CONTACTS, {
                            params: { shippingLocationId: shippingLocation.id }
                        }).then(results => {
                            const contacts = results.data.data.results
                            const hazContact = contacts?.find(contact => contact.type === "Emergency/Haz")
                            if(hazContact){
                                setFormikValues('emergencyContact', `${hazContact.firstName} ${hazContact.lastName}`)
                                setFormikValues('emergencyPhone', hazContact.phone)
                            }
                        }).catch(() => {})
                    }
                }
            }else{
                if(forVendorRequest){
                    setFormikValues(`${valueName}.address1`, shippingLocation?.address || "")
                    setFormikValues(`${valueName}.address2`, shippingLocation?.address1 || "")
                }

                // Get the 2-letter country code for checking countries without zipcodes
                const countryCode2Letter = shippingLocation?.country?.length === 3
                    ? CountryOptions.filter(c => c.CodePrimus === shippingLocation.country)[0]?.Code || shippingLocation.country
                    : shippingLocation.country || "US"
                const isCountryWithoutZipcode = getCountriesWithoutZipcodes().includes(countryCode2Letter)
                const hasCity = !!shippingLocation?.city
                const hasZipcode = !!shippingLocation?.zipcode
                // Infer isCity for countries without zipcodes
                const inferredIsCity = isCountryWithoutZipcode && hasCity && !hasZipcode

                setData(forVendorRequest ? {
                    'Zipcode': shippingLocation?.zipcode,
                    'State': shippingLocation?.state,
                    'City': shippingLocation?.city,
                    'isSL': true,
                    'isZipcode': false,
                    'isCity': inferredIsCity,
                    'isPort':false,
                    'Name': shippingLocation?.name,
                    'id': shippingLocation?.id,
                    'address1': shippingLocation.address || "",
                    'address2': shippingLocation.address1 || "",
                    'Remarks': shippingLocation?.remarks
                }
                    : {
                    'Zipcode': shippingLocation?.zipcode || shippingLocation?.postalCode,
                    'State': shippingLocation?.state || shippingLocation?.stateCode,
                    'City': shippingLocation?.city || shippingLocation?.cityAlias,
                    'Country': countryCode2Letter,
                    'isSL': true,
                    'isZipcode': false,
                    'isCity': inferredIsCity,
                    'isPort': shippingLocation?.isPort ? true : false,
                    'Name': shippingLocation?.name,
                    'id': shippingLocation?.id,
                    'Remarks': shippingLocation?.remarks,
                    'IATACode': shippingLocation?.IATA
                })
            }

            if(forStops && formFor !== 'pickupLocation'){
                setData(shippingLocation)
                setShippingLocationLocal(shippingLocation?.name)
                setFormikValues(`name`, shippingLocation?.name || "")
                setFormikValues(`address`, shippingLocation?.address || "")
                setFormikValues(`address1`, shippingLocation?.address1 || "")
                setFormikValues(`contact`, shippingLocation?.contact || "")
                setFormikValues(`id`, shippingLocation?.id || "")
                setFormikValues(`city`, shippingLocation?.city || "")
                setFormikValues(`country`, shippingLocation?.country || "US")
                setFormikValues(`state`, shippingLocation?.state || "")
                setFormikValues(`zipcode`, shippingLocation?.zipcode || "")
                setFormikValues(`phone`, formatPhone(shippingLocation?.phone, shippingLocation.country) || "")
                setFormikValues(`contactPhone`, formatPhone(shippingLocation?.contactPhone, shippingLocation.country) || "")
                setFormikValues(`remarks`, shippingLocation?.remarks || "")
            }
            
            setOpen(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shippingLocation])

    return (
        <ModalStyled
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            fontSize={fontSize}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paperEditModalSL} style={{visibility: 'visible', opacity: '100%'}}>
                    <>
                        <SLTable
                            setShippingLocation={setShippingLocation}
                            open={open}
                            setOpen={setOpen}
                            setOpenClearRateToEditModal={setOpenClearRateToEditModal}
                            setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
                            formikValues={formikValues}
                            formFor={formFor}
                            handleClose={handleClose}
                            notStylized={true}
                            data={data}
                            setOpenRemarksMessageModal={setOpenRemarksMessageModal}
                            forDrayage={forDrayage}
                            userData={userData}
                        />
                    </>
                    <div className="row mb-3 mt-5">
                        <div className="col-12 d-flex justify-content-end">
                            <button
                                className="btn btn-secondary"
                                onClick={handleClose}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </Fade>
        </ModalStyled>
    )
}

export default ShippingLocationsModal